module.exports = __webpack_public_path__ + "img/Keith_Fandrick.866e5134.png";